import "../styles/index.css"
import "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"
import WordmarkController from "./controllers/wordmark_controller.js"
import HeaderController from "./controllers/header_controller.js"

const application = Application.start()
application.register("wordmark", WordmarkController)
application.register("header", HeaderController)
